var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("breadcrumbs", { attrs: { items: _vm.breadcrumbs } }),
      _c("v-container", [
        _c(
          "div",
          { staticClass: "container-user" },
          [
            _c(
              "div",
              { staticClass: "round-action" },
              [
                _c(
                  "v-row",
                  { staticClass: "btn-div", attrs: { justify: "start" } },
                  [
                    _c("v-col", [
                      _c(
                        "div",
                        { staticClass: "area-search-box" },
                        [
                          _c(
                            "v-row",
                            {
                              attrs: {
                                "no-gutters": "",
                                justify: "space-between",
                              },
                            },
                            [
                              _c(
                                "v-col",
                                [
                                  _c("searchbox", {
                                    staticClass: "input-search",
                                    attrs: {
                                      searchTargetItems: _vm.searchTargetItems,
                                      title:
                                        _vm.configData
                                          .TEXT_EQUIPMENT_STATUS_TITLE,
                                      dataArea: _vm.dataArea,
                                      dataOffice: _vm.dataOffice,
                                      isCSV: true,
                                    },
                                    on: {
                                      search: function ($event) {
                                        return _vm.$emit("search", $event)
                                      },
                                      "change-office": function ($event) {
                                        return _vm.changeOffice($event)
                                      },
                                      export: function ($event) {
                                        return _vm.$emit("export")
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.errorMessageLogs !== ""
              ? _c(
                  "v-col",
                  { staticClass: "mt-5 mb-4 font-weight-bold mt-1 bg-error" },
                  [_vm._v(" " + _vm._s(_vm.errorMessageLogs) + " ")]
                )
              : _vm._e(),
            _vm.loadingSearch === false
              ? _c("equipment-status-list", {
                  attrs: {
                    loading: _vm.loading,
                    resData: _vm.resData,
                    total: _vm.total,
                  },
                  on: {
                    "change-column": function ($event) {
                      return _vm.$emit("change-column", $event)
                    },
                    "get-current-items": function ($event) {
                      return _vm.$emit("get-current-items", $event)
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }